module.exports = __webpack_public_path__ + "static/media/apple.70e7ea39.png";